import {
  Box,
  Button,
  Checkbox,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core"
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline"
import DeleteIcon from "@material-ui/icons/Delete"
import ClerkAppContext from "contexts/Clerk/ClerkApp"
import { useFormikContext } from "formik"
import PropTypes from "prop-types"
import { useContext } from "react"

import useStyles from "./styles"

const Step4 = ({
  additionalQuestions,
  setAdditionalQuestions,
  newQuestion,
  setNewQuestion,
  defaultQuestions,
  setDefaultQuestions,
}) => {
  const { values, setFieldValue } = useFormikContext()
  const classes = useStyles()
  const { options } = useContext(ClerkAppContext)

  const handleChangeDefaultQuestions = (question) => {
    if (defaultQuestions?.includes(question?.id)) {
      setDefaultQuestions((oldState) =>
        oldState.filter((x) => x !== question?.id)
      )
      setFieldValue(
        "default_questions",
        values?.default_questions.filter((x) => x !== question?.id)
      )
    } else {
      setDefaultQuestions((oldState) => [...oldState, question?.id])
      setFieldValue("default_questions", [
        ...values.default_questions,
        question?.id,
      ])
    }
  }

  const handleChangeAdditionalQuestions = (question) => {
    setAdditionalQuestions((oldState) => oldState.filter((x) => x !== question))
    setFieldValue("additional_questions", [
      ...values?.additional_questions.filter((x) => x !== question),
    ])
  }

  return (
    <Box>
      <Typography className={classes.label}>
        Default application questions
      </Typography>
      {options?.default_questions?.map((question, i) => {
        return (
          <Box
            key={question?.id}
            width="100%"
            display="flex"
            alignItems="center"
          >
            <Checkbox
              checked={defaultQuestions.includes(question?.id)}
              value={question?.id}
              onChange={() => handleChangeDefaultQuestions(question)}
              inputProps={{ "aria-label": "primary checkbox" }}
            />
            <Typography>{question?.question} </Typography>
          </Box>
        )
      })}
      <Typography className={classes.label} style={{ marginTop: "10px" }}>
        Additional application questions
      </Typography>
      <Box display="flex" alignItems="center">
        <TextField
          id="outlined-basic"
          variant="outlined"
          value={newQuestion}
          style={{ width: "80%" }}
          onChange={(e) => setNewQuestion(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              setNewQuestion("")
              setAdditionalQuestions((oldState) => [...oldState, newQuestion])
              setFieldValue("additional_questions", [
                ...values?.additional_questions,
                newQuestion,
              ])
            }
          }}
        />
        <Button
          disabled={newQuestion === ""}
          onClick={() => {
            setNewQuestion("")
            setAdditionalQuestions((oldState) => [...oldState, newQuestion])
            setFieldValue("additional_questions", [
              ...values?.additional_questions,
              newQuestion,
            ])
          }}
          startIcon={<AddCircleOutlineIcon />}
        >
          <Typography>Add question</Typography>
        </Button>
      </Box>
      {additionalQuestions.map((question, i) => {
        return (
          <Box key={i} width="100%" display="flex" alignItems="center">
            <IconButton
              color="primary"
              onClick={() => handleChangeAdditionalQuestions(question)}
            >
              <DeleteIcon />
            </IconButton>
            <Typography>{question} </Typography>
          </Box>
        )
      })}
    </Box>
  )
}

Step4.propTypes = {
  additionalQuestions: PropTypes.array,
  setAdditionalQuestions: PropTypes.func,
  newQuestion: PropTypes.string,
  setNewQuestion: PropTypes.func,
  defaultQuestions: PropTypes.array,
  setDefaultQuestions: PropTypes.func,
}

export default Step4
